export default __webpack_public_path__ + "static/media/icon-hamburger.f8a9f0cf.svg";